import { render, staticRenderFns } from "./rolePlayfiles.vue?vue&type=template&id=9938a0f6&scoped=true&"
import script from "./rolePlayfiles.vue?vue&type=script&lang=ts&"
export * from "./rolePlayfiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9938a0f6",
  null
  
)

export default component.exports